type Kind = 'deposit' | 'withdraw';
const normalized = (status?: string) => String(status || '').trim().toLowerCase();
export function orderStatusBucket(status?: string, kind?: Kind): 'completed' | 'pending' | 'failed' {
  const value = normalized(status);
  if (['success', 'paid', 'completed', 'done', 'adjusted'].includes(value)) return 'completed';
  if (value === 'approved' && kind === 'deposit') return 'completed';
  if (['rejected', 'cancelled', 'canceled', 'failed', 'expired', 'refused', 'denied', 'error'].includes(value)) return 'failed';
  // Unknown states must not claim a failed payment or successful payout.
  return 'pending';
}
export function orderStatusLabelKey(status?: string, kind?: Kind) {
  const value = normalized(status);
  if (['rejected', 'refused', 'denied'].includes(value)) return 'paymentStatusRejected';
  if (['cancelled', 'canceled'].includes(value)) return 'paymentStatusCancelled';
  if (value === 'expired') return 'paymentStatusExpired';
  const bucket = orderStatusBucket(status, kind);
  if (bucket === 'completed') return 'walletStatusCompleted';
  if (bucket === 'failed') return 'walletStatusFailed';
  if (kind === 'withdraw' && ['review', 'created', 'submitted'].includes(value)) return 'paymentStatusReview';
  if (kind === 'withdraw' && ['approved', 'pending_payout', 'processing'].includes(value)) return 'paymentStatusPayout';
  return 'walletStatusPending';
}
